// Angular
import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ProductService } from '@app/api/product.service';

import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from 'environments/environment';

interface Suggestions {
  name: string;
  image: string;
}

@Component({
  selector: 'kt-search-suggestions',
  templateUrl: './search-suggestions.component.html',
  styleUrls: ['./search-suggestions.component.scss'],
})
export class SearchSuggestionsComponent implements OnInit {
  searchValue: string = '';
  showSuggestions: boolean = false;
  // suggestions: string[] = [];
  suggestions: Suggestions[] = [];
  isLoading: boolean = false;
  host: string = environment.backendhost;
  private searchSubject: Subject<string> = new Subject();
  private searchSub: Subscription;
  activeTab: number = -1;
  maxItemSuggestions: number = 0;
  minSearchLength: number = 2;
  selectedFile; 
  previewUrl;
  @ViewChild('imageInput', { static: false }) imageInput: ElementRef;

  constructor(
    private product: ProductService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.searchSub = this.searchSubject.pipe(debounceTime(300)).subscribe((value) => {
      this.getSuggestions(value);
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!event.url.includes('/searchresultpage')) {
          this.searchValue = '';
          this.showSuggestions = false;
        }
      });

    this.route.queryParams.subscribe((params) => {
      if (params['search']) {
        this.searchValue = params['search'];
      }
    });
  }

  // openImagePicker(event?: MouseEvent) {
  //   if (event) {
  //     event.stopPropagation();
  //   }
  //   if (this.imageInput && this.imageInput.nativeElement) {
  //     this.imageInput.nativeElement.value = '';
  //     this.imageInput.nativeElement.click();
  //   }
  // }

  openFilePicker() {
    this.imageInput.nativeElement.click();
  }
  onImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    console.log('input file ne', input);
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    this.selectedFile = file;
    console.log('Selected file:', this.selectedFile);
    // (Optional) Preview ảnh
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;

      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);
    this.getImageSearch();
  }

  getImageSearch() {
    if (!this.selectedFile) {
      return;
    } else {
      this.product.apiImageSearchPost(this.selectedFile).subscribe((res) => {
        if (res.success) {
          console.log('res co img la', res.collection.data);
        }
      });
    }
  }

  // onImageSelected(event: any) {
  //   const file: File = event.target.files && event.target.files[0];
  //   console.log('file image ne', file);
  //   if (!file) {
  //     return;
  //   } else {
  //     this.isLoading = true;
  //     // call the new image search API
  //     this.product.apiImageSearchPost(file).subscribe(
  //       (res) => {
  //         this.isLoading = false;
  //         console.log('res co img la', res.data);
  //         if (res && res.success) {
  //         } else {
  //         }
  //       },
  //       (err) => {
  //         this.isLoading = false;
  //         console.error('imageSearch error', err);
  //       }
  //     );
  //   }
  // }

  onFocus() {
    if (this.searchValue.trim().length >= this.minSearchLength && this.suggestions.length > 0) {
      this.showSuggestions = true;
    }
  }
  onSearchValueChange(value: string) {
    const trimmed = value.trim();
    if (trimmed.length < this.minSearchLength) {
      this.showSuggestions = false;
      this.suggestions = [];
      this.isLoading = false;
      return;
    }
    this.isLoading = true;
    this.showSuggestions = true;
    this.searchSubject.next(value);
  }
  getSuggestions(value: string) {
    const trimmed = value.trim();
    if (!trimmed || trimmed.length < this.minSearchLength) {
      this.suggestions = [];
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.product.apiProductsSuggestionsGet(value.trim()).subscribe((res) => {
      if (res.success) {
        this.suggestions = res.data;
        console.log('gia tri la kaka', this.suggestions);
        this.maxItemSuggestions = res.data.length - 1;
        this.isLoading = false;
        this.showSuggestions = true;
        this.cdr.detectChanges();
      }
    });
  }
  handleDelete() {
    this.searchValue = '';
  }
  onKeyDown(event: KeyboardEvent) {
    const maxIndex = this.suggestions.length - 1;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeTab = this.activeTab < maxIndex ? this.activeTab + 1 : 0;
      this.searchValue = this.suggestions[this.activeTab].name;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeTab = this.activeTab > 0 ? this.activeTab - 1 : maxIndex;
      this.searchValue = this.suggestions[this.activeTab].name;
    }

    this.cdr.detectChanges();
  }

  nextPageSearch(value?: string) {
    const newValue = value || this.searchValue;
    this.showSuggestions = false;
    this.searchValue = newValue;
    this.router.navigate(['/searchresultpage'], {
      queryParams: { search: newValue },
    });
  }

  hideSuggestions() {
    this.showSuggestions = false;
  }

  ngOnDestroy(): void {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.search-suggestions-container')) {
      this.showSuggestions = false;
    }
  }
}
